export default "__VITE_ASSET__a2f0abe1__"